export const REDUCER_NAME = "app";

export const SET_ERROR_MESSAGE = "App/SET_ERROR_MESSAGE";
